import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getPropertyDetails, scheduleTour } from './GetPropertyApi';

const initialState = {
  property: null,
  status: 'idle',
  error: null,
  data: null,
};
export const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPropertyDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getPropertyDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.property = action.payload;
      })
      .addCase(getPropertyDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(scheduleTour.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(scheduleTour.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(scheduleTour.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });

  },
});
export default propertySlice.reducer;
